import React from 'react'
import { connect } from 'react-redux'
import Button from '@cx/couturier/Button'

function LogBackInBtn ({ logBackInUrl, passedClass }) {
  return (
    <a className={passedClass} href={logBackInUrl}>
      <Button>Log back in</Button>
    </a>
  )
}

const mapStateToProps = (state) => ({
  logBackInUrl: state.meta.statefulRedirect
})

export default connect(mapStateToProps)(LogBackInBtn)
